import DataAccess from "../DataAccessStrategy";

export default class FormaPagamento extends DataAccess {
  constructor() {
    super("FormaPagamento", {
      id: Number,
      shouldSync: Boolean,
      updatedDate: Date,
      nome: String,
    });
  }
}
